const KONAMI_CODE_SEQUENCE = [
	'arrowup',
	'arrowup',
	'arrowdown',
	'arrowdown',
	'arrowleft',
	'arrowright',
	'arrowleft',
	'arrowright',
	'b',
	'a'
];

const KONAMI_CODE_SEQUENCE_WITH_ENTER = [...KONAMI_CODE_SEQUENCE, 'enter'];

// - - - - - - - - - - - - - - - - - - - - - - - - - - - -

function triggerEvent (target, type, detail = {})
{
	let event, bubbles = true, cancelable = true;

	if (typeof window.CustomEvent === 'function')
	{
		event = new window.CustomEvent(type, {
			detail, bubbles, cancelable
		});
	}
	else
	{
		event = document.createEvent('CustomEvent');
		/* eslint-disable */
		// Initialize the old-fashioned way.
		event.initCustomEvent(type, bubbles, cancelable, detail);
		/* eslint-enable */
	}

	target.dispatchEvent(event);
}

// - - - - - - - - - - - - - - - - - - - - - - - - - - - -

export function addSupportForTheKonamiCode ({
	requireEnterPress = false, allowedTimeBetweenKeys = 0
} = {})
{
	let sequence = KONAMI_CODE_SEQUENCE, timer = null, progress = 0;

	if (requireEnterPress)
	{
		sequence = KONAMI_CODE_SEQUENCE_WITH_ENTER;
	}

	function konamiCodeSequenceListener (event)
	{
		if (timer)
		{
			clearTimeout(timer);
		}

		if (event.key === undefined)
		{
			return;
		}

		if (sequence[progress] !== event.key.toLowerCase())
		{
			timer    = null;
			progress = 0;

			return;
		}

		++progress;

		if (sequence.length === progress)
		{
			timer    = null;
			progress = 0;

			triggerEvent(event.target, 'konamicode', {
			});

			return;
		}

		if (allowedTimeBetweenKeys > 0)
		{
			timer = setTimeout(function resetSequenceIfUserTakesTooLong ()
			{
				timer    = null;
				progress = 0;

			}, allowedTimeBetweenKeys);
		}
	}

	document.addEventListener('keydown', konamiCodeSequenceListener, true);

	return function removeSupportForTheKonamiCode ()
	{
		document.removeEventListener('keydown', konamiCodeSequenceListener, true);
	};
}
